import SimpleDownloadReportPopup from './SimpleDownloadReportPopup';

export default SimpleDownloadReportPopup;
